import { Link, Offer, NameBanner } from '@rumblefish/ui/Rumblefish23Theme';

import { fintechServicesData } from './FintechServices.data';
import type { FintechServicesProps } from './FintechServices.types';
import {
  StyledStack,
  StyledButton,
  StyledSection,
  StyledLinkWrapper,
  SectionNameBannerStack,
} from './styles';

export const FintechServices = ({
  offerRef,
  ...props
}: FintechServicesProps): React.ReactElement => {
  return (
    <>
      <StyledSection width="normal">
        <StyledStack {...props}>
          <SectionNameBannerStack>
            <NameBanner type="section" text="Services" color="raspberry" />
          </SectionNameBannerStack>
        </StyledStack>
      </StyledSection>

      <Offer
        title={fintechServicesData.mainText}
        description={fintechServicesData.description}
        data={fintechServicesData.services}
        CustomButton={
          <StyledLinkWrapper>
            <Link to="/contact">
              <StyledButton>Book a free consultation</StyledButton>
            </Link>
          </StyledLinkWrapper>
        }
        ref={offerRef}
      />
    </>
  );
};
